// @ts-nocheck

class TSCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.isLoading = false;
  }

  connectedCallback() {
    this.initClickEvents();
    
    document.addEventListener("click", (e) => {
      if (e.target.hasAttribute("cart-drawer-toggle")) {
        this.open();
      }
    })
  }

  updateQuantity(item, quantity, itemEl = false) {
    this.toggleLoading(itemEl);
    
    const data = {
      id: item,
      quantity: quantity,
      sections: ["ts-cart-drawer"],
      sections_url: window.location.pathname
    }

    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    .then(response => response.json())
    .then(response => {
      if (response.sections) {
        this.renderContent(response.sections);
      } else {
        throw new Error(response.description);
      }
    })
    .catch((error) => {
      const itemEl = this.querySelector(`[data-item="${item}"]`);
      const messageBlock = itemEl.querySelector("[item-notification]");

      console.error('Error:', error);

      messageBlock.innerText = error.message;
      setTimeout(() => {messageBlock.innerText = ""}, 5000);
    })
    .finally(() => {this.toggleLoading(itemEl)});
  }

  renderContent(sections) {
    if (!sections['ts-cart-drawer']) return;

    const html = new DOMParser().parseFromString(sections['ts-cart-drawer'], "text/html");
    const newCartDrawer = html.querySelector("ts-cart-drawer");
    
    this.querySelector("[js-content]").innerHTML = newCartDrawer.querySelector("[js-content]").innerHTML;
    this.setAttribute("data-count", newCartDrawer.dataset.count);

    document.querySelectorAll("[cart-item-count]").forEach(countEl => countEl.innerText = newCartDrawer.dataset.count);
  }

  initClickEvents() {
    this.addEventListener("click", (e) => {
      if (e.target.hasAttribute("data-action")) {
        e.preventDefault();
  
        const item = e.target.closest("[data-item]");
        const itemQuantityInput = item?.querySelector('[name="quantity"]') ?? false;
        const itemQuantity = parseInt(itemQuantityInput?.value) ?? false;
  
        switch (e.target.dataset.action) {
          case "close":
            this.close();
            break;
          case "remove-item":
            if (!this.isLoading) {
              this.updateQuantity(item.dataset.item, 0);
            }
            break;
        }
      }
    })
  }

  toggleLoading(itemEl) {
    this.isLoading = !this.isLoading;
    this.classList.toggle("loading-item", this.isLoading);

    if (itemEl) {
      itemEl.classList.toggle("loading", this.isLoading);
    }
  }

  open() {
    this.classList.add("open");
    document.documentElement.style.overflow = "hidden";
  }

  close() {
    this.classList.remove("open");
    document.documentElement.style.overflow = null;
  }
}

if (document.querySelector("ts-cart-drawer")) {
  customElements.define("ts-cart-drawer", TSCartDrawer);
}